export const REVIT_URI_SCHEME = 'bamt-revit://';
